{
  "HELP_CENTER": {
    "TITLE": "Palaikymo centras",
    "NEW_PAGE": {
      "DESCRIPTION": "Sukurkite savitarnos pagalbos centro portalus savo klientams. Padėkite jiems greitai rasti atsakymus, nelaukiant. Supaprastinkite užklausų tvarkymą, padidinkite agentų efektyvumą ir pagerinkite klientų aptarnavimą.",
      "CREATE_PORTAL_BUTTON": "Sukurti Portalą"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Be pavadinimo"
    },
    "HEADER": {
      "FILTER": "Filtruoti pagal",
      "SORT": "Rūšiuoti pagal",
      "LOCALE": "Lokalizacija",
      "SETTINGS_BUTTON": "Nustatymai",
      "NEW_BUTTON": "Naujas Straipsnis",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Paskelbta",
        "DRAFT": "Draft",
        "ARCHIVED": "Suarchyvuota"
      },
      "TITLES": {
        "ALL_ARTICLES": "Visi Straipsniai",
        "MINE": "Mano Straipsniai",
        "DRAFT": "Straipsnių juodraščiai",
        "ARCHIVED": "Suarchyvuoti Straipsniai"
      },
      "LOCALE_SELECT": {
        "TITLE": "Pasirinkti lokalizaciją",
        "PLACEHOLDER": "Pasirinkti lokalizaciją",
        "NO_RESULT": "Lokalizacijų nerasta",
        "SEARCH_PLACEHOLDER": "Ieškoti lokalizacijos"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Visi Straipsniai",
      "PUBLISH_BUTTON": "Skelbti",
      "MOVE_TO_ARCHIVE_BUTTON": "Perkelti į archyvuotą",
      "PREVIEW": "Peržiūrėti",
      "ADD_TRANSLATION": "Pridėti vertimą",
      "OPEN_SIDEBAR": "Atidaryti šoninę juostą",
      "CLOSE_SIDEBAR": "Uždaryti šoninę juostą",
      "SAVING": "Išsaugoma...",
      "SAVED": "Išsaugota"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Įkelti paveikslėlį",
        "UPLOADING": "Įkeliama...",
        "SUCCESS": "Paveiksliukas sėkmingai įkeltas",
        "ERROR": "Klaida įkeliant paveiksliuką",
        "UN_AUTHORIZED_ERROR": "Jūs neturite teisės įkelti paveikslėlių",
        "ERROR_FILE_SIZE": "Paveiksliuko dydis turi būti mažesnis nei {size} MB",
        "ERROR_FILE_FORMAT": "Paveiksliuko formatas turi būti jpg, jpeg arba png",
        "ERROR_FILE_DIMENSIONS": "Paveiksliuko matmenys turi būti mažesni nei 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Įterpti inkarą",
        "TITLE": "Įterpti inkarą",
        "SUBMIT": "Įterpti",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Straipsnio Nustatymai",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Kategorija",
          "TITLE": "Pasirinkti kategoriją",
          "PLACEHOLDER": "Pasirinkti kategoriją",
          "NO_RESULT": "Kategorijų nerasta",
          "SEARCH_PLACEHOLDER": "Ieškoti kategorijos"
        },
        "AUTHOR": {
          "LABEL": "Autorius",
          "TITLE": "Pasirinkite autorių",
          "PLACEHOLDER": "Pasirinkite autorių",
          "NO_RESULT": "Autorių nerasta",
          "SEARCH_PLACEHOLDER": "Ieškoti autoriaus"
        },
        "META_TITLE": {
          "LABEL": "Meta antraštė",
          "PLACEHOLDER": "Pridėkite meta antraštę"
        },
        "META_DESCRIPTION": {
          "LABEL": "Meta aprašymas",
          "PLACEHOLDER": "Pridėkite meta aprašą, kad gautumėte geresnius SEO rezultatų..."
        },
        "META_TAGS": {
          "LABEL": "Meta žymos",
          "PLACEHOLDER": "Pridėti meta žymes, atskirtas kableliais..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Archyvuoti straipsnį",
        "DELETE": "Ištrinti straipsnį"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Neįtraukta į kategorijas",
      "SEARCH_RESULTS": "Paieškos rezultatai: {query}",
      "EMPTY_TEXT": "Ieškokite straipsnių, kuriuos norite įterpti į atsakymus.",
      "SEARCH_LOADER": "Ieškoma...",
      "INSERT_ARTICLE": "Įterpti",
      "NO_RESULT": "Straipsnių nerasta",
      "COPY_LINK": "Nukopijuokite straipsnio nuorodą į iškarpinę",
      "OPEN_LINK": "Atidaryti straipsnį naujame skirtuke",
      "PREVIEW_LINK": "Straipsnio peržiūra"
    },
    "PORTAL": {
      "HEADER": "Portalas",
      "DEFAULT": "Pagal nutylėjimą",
      "NEW_BUTTON": "Naujas portalas",
      "ACTIVE_BADGE": "aktyvus",
      "CHOOSE_LOCALE_LABEL": "Pasirinkite lokalizaciją",
      "LOADING_MESSAGE": "Įkeliami portalai...",
      "ARTICLES_LABEL": "straipsniai",
      "NO_PORTALS_MESSAGE": "Nėra pasiekiamų portalų",
      "ADD_NEW_LOCALE": "Pridėti naują lokalizaciją",
      "POPOVER": {
        "TITLE": "Portalas",
        "PORTAL_SETTINGS": "Portalo nustatymai",
        "SUBTITLE": "Turite kelis portalus ir kiekvienam portalui galite turėti skirtingas lokalizacijas.",
        "CANCEL_BUTTON_LABEL": "Atšaukti",
        "CHOOSE_LOCALE_BUTTON": "Pasirinkite lokalizaciją"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "straipsniai",
            "ADD": "Pridėti lokalizaciją",
            "VISIT": "Apsilankykite svetainėje",
            "SETTINGS": "Nustatymai",
            "DELETE": "Ištrinti"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Portalo konfiguracija",
            "ITEMS": {
              "NAME": "Vardas",
              "DOMAIN": "Personalizuotas domenas",
              "SLUG": "Slug",
              "TITLE": "Portalo antraštė",
              "THEME": "Temos spalva",
              "SUB_TEXT": "Portalo subtekstas"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Prieinamos personalizacijos",
            "TABLE": {
              "NAME": "Vietos pavadinimas",
              "CODE": "Vietos kodas",
              "ARTICLE_COUNT": "Straipsnių kiekis",
              "CATEGORIES": "Kategorijų kiekis",
              "SWAP": "Sukeisti",
              "DELETE": "Ištrinti",
              "DEFAULT_LOCALE": "Pagal nutylėjimą"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Trinti portalą",
          "MESSAGE": "Ar tikrai norite ištrinti šį portalą",
          "YES": "Taip, trinti portalą",
          "NO": "Ne, išlaikyti portalą",
          "API": {
            "DELETE_SUCCESS": "Portalas ištrintas sėkmingai",
            "DELETE_ERROR": "Trinant portalą įvyko klaida"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Portalo redagavimas",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Pagrindinė informacija"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Portalo pritaikymas"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Kategorijos"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Lokalizacija"
          }
        },
        "CATEGORIES": {
          "TITLE": "Kategorijos",
          "NEW_CATEGORY": "Nauja kategorija",
          "TABLE": {
            "NAME": "Vardas",
            "DESCRIPTION": "Aprašymas",
            "LOCALE": "Lokalizacija",
            "ARTICLE_COUNT": "Straipsnių kiekis",
            "ACTION_BUTTON": {
              "EDIT": "Keisti kategoriją",
              "DELETE": "Ištrinti kategoriją"
            },
            "EMPTY_TEXT": "Kategorijų nerasta"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Atnaujinkite pagrindinius nustatymus"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Pagalbos centro informacija",
            "BODY": "Pagrindinė informacija apie portalą"
          },
          "CUSTOMIZATION": {
            "TITLE": "Pagalbos centro pritaikymas",
            "BODY": "Portalo pritaikymas"
          },
          "FINISH": {
            "TITLE": "Baigta! 🎉",
            "BODY": "Viskas paruošta!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Atgal",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Sukurti Portalą",
            "TITLE": "Pagalbos centro informacija",
            "CREATE_BASIC_SETTING_BUTTON": "Sukurkite pagrindinius portalo nustatymus"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Portalo pritaikymas",
            "TITLE": "Pagalbos centro pritaikymas",
            "UPDATE_PORTAL_BUTTON": "Atnaujinkite portalo nustatymus"
          },
          "FINISH_PAGE": {
            "TITLE": "Baigta!🎉 Viskas paruošta!",
            "MESSAGE": "Dabar galite pamatyti šį sukurtą portalą visų portalų puslapyje.",
            "FINISH": "Eikite į visų portalų puslapį"
          }
        },
        "LOGO": {
          "LABEL": "Logotipas",
          "UPLOAD_BUTTON": "Įkelti logotipą",
          "HELP_TEXT": "Šis logotipas bus rodomas portalo antraštėje.",
          "IMAGE_UPLOAD_SUCCESS": "Logotipas sėkmingai įkeltas",
          "IMAGE_UPLOAD_ERROR": "Logotipas sėkmingai ištrintas",
          "IMAGE_DELETE_ERROR": "Klaida trinant logotipą"
        },
        "NAME": {
          "LABEL": "Vardas",
          "PLACEHOLDER": "Portalo pavadinimas",
          "HELP_TEXT": "Pavadinimas bus naudojamas viešajame portale.",
          "ERROR": "Yra reikalingas vardas"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portalo slug url adresui",
          "ERROR": "Yra reikalingas slug"
        },
        "DOMAIN": {
          "LABEL": "Personalizuotas domenas",
          "PLACEHOLDER": "Portalo personalizuotas domenas",
          "HELP_TEXT": "Pridėkite tik tuo atveju, jei norite naudoti pasirinktinį domeną savo portalams. Pvz.: {exampleURL}",
          "ERROR": "Įveskite galiojantį domaino URL"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Nuoroda į pagrindinį puslapį",
          "PLACEHOLDER": "Portalo nuoroda į pagrindinį puslapį",
          "HELP_TEXT": "Nuoroda, naudojama grįžti iš portalo į pagrindinį puslapį. Pvz.: {exampleURL}",
          "ERROR": "Įveskite galiojantį pagrindinio puslapio URL"
        },
        "THEME_COLOR": {
          "LABEL": "Portalo temos spalva",
          "HELP_TEXT": "Ši spalva bus rodoma kaip portalo temos spalva."
        },
        "PAGE_TITLE": {
          "LABEL": "Puslapio Antraštė",
          "PLACEHOLDER": "Portalo puslapio antraštė",
          "HELP_TEXT": "Puslapio pavadinimas bus naudojamas viešame portale.",
          "ERROR": "Yra reikalingas puslapio pavadinimas"
        },
        "HEADER_TEXT": {
          "LABEL": "Antraštės tekstas",
          "PLACEHOLDER": "Portalo antraštės tekstas",
          "HELP_TEXT": "Portalo antraštės tekstas bus naudojamas viešame portale.",
          "ERROR": "Yra reikalingas portalo antraštės tekstas"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portalas sukurtas sėkmingai.",
          "ERROR_MESSAGE_FOR_BASIC": "Nepavyko sukurti portalo. Bandykite dar kartą.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portalas atnaujintas sėkmingai.",
          "ERROR_MESSAGE_FOR_UPDATE": "Nepavyko atnaujinti portalo. Bandykite dar kartą."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Pridėti naują lokalizaciją",
        "SUB_TITLE": "Tai prideda naują lokalizaciją prie galimų vertimų sąrašo.",
        "PORTAL": "Portalas",
        "LOCALE": {
          "LABEL": "Lokalizacija",
          "PLACEHOLDER": "Pasirinkite lokalizaciją",
          "ERROR": "Yra reikalinga lokalizacija"
        },
        "BUTTONS": {
          "CREATE": "Sukurti lokalizaciją",
          "CANCEL": "Atšaukti"
        },
        "API": {
          "SUCCESS_MESSAGE": "Lokalizacija sėkmingai pridėta",
          "ERROR_MESSAGE": "Nepavyko pridėti lokalizacijos. Bandykite dar kartą."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Numatytoji lokalizacija sėkmingai atnaujinta",
          "ERROR_MESSAGE": "Nepavyko atnaujinti numatytosios lokalizacijos. Bandykite dar kartą."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Lokalizacija sėkmingai pašalinta iš portalo",
          "ERROR_MESSAGE": "Nepavyko pašalinti lokalizacijos iš portalo. Bandykite dar kartą."
        }
      }
    },
    "TABLE": {
      "404": "Nė vienas straipsnis neatitinka jūsų paieškos 🔍",
      "LOADING_MESSAGE": "Įkeliami straipsniai...",
      "NO_ARTICLES": "Nėra pasiekiamų straipsnių",
      "HEADERS": {
        "TITLE": "Pavadinimas",
        "CATEGORY": "Kategorija",
        "READ_COUNT": "Peržiūros",
        "STATUS": "Būsena",
        "LAST_EDITED": "Paskutinį kartą redaguota"
      },
      "COLUMNS": {
        "BY": "pateikė",
        "AUTHOR_NOT_AVAILABLE": "Autorius nepasiekiamas"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Įkeliamas straipsnis...",
      "TITLE_PLACEHOLDER": "Straipsnio pavadinimas pateikiamas čia",
      "CONTENT_PLACEHOLDER": "Rašykite straipsnį čia",
      "API": {
        "ERROR": "Išsaugant straipsnį įvyko klaida"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Skelbiant straipsnį įvyko klaida",
        "SUCCESS": "Straipsnis sėkmingai paskelbtas"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Archyvuojant straipsnį įvyko klaida",
        "SUCCESS": "Straipsnis sėkmingai suarchyvuotas"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Klaida rengiant straipsnio juodraštį",
        "SUCCESS": "Straipsnio juodraštis sėkmingai sukurtas"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Patvirtinti Ištrynimą",
          "MESSAGE": "Ar tikrai norite ištrinti straipsnį?",
          "YES": "Taip, Ištrinti",
          "NO": "Ne, Išsaugoti"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Straipsnis ištrintas sėkmingai",
        "ERROR_MESSAGE": "Trinant straipsnį įvyko klaida"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Pridėkite straipsnio antraštę ir turinį, tada tik jūs galėsite atnaujinti nustatymus"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Ieškoti straipsnių"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Sukurti kategoriją",
        "SUB_TITLE": "Kategorija bus naudojama viešajame portale straipsniams skirstyti į kategorijas.",
        "PORTAL": "Portalas",
        "LOCALE": "Lokalizacija",
        "NAME": {
          "LABEL": "Vardas",
          "PLACEHOLDER": "Kategorijos pavadinimas",
          "HELP_TEXT": "Kategorijos pavadinimas ir piktograma bus naudojamas viešajame portale straipsniams skirstyti į kategorijas.",
          "ERROR": "Yra reikalingas vardas"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug kategorija, skirta URL",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Yra reikalingas slug"
        },
        "DESCRIPTION": {
          "LABEL": "Aprašymas",
          "PLACEHOLDER": "Pateikite trumpą kategorijos aprašymą.",
          "ERROR": "Būtinas aprašymas"
        },
        "BUTTONS": {
          "CREATE": "Sukurti kategoriją",
          "CANCEL": "Atšaukti"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategorija sukurta sėkmingai",
          "ERROR_MESSAGE": "Nepavyko sukurti kategorijos"
        }
      },
      "EDIT": {
        "TITLE": "Keisti kategoriją",
        "SUB_TITLE": "Kategorijos redagavimas atnaujins kategoriją viešajame portale.",
        "PORTAL": "Portalas",
        "LOCALE": "Lokalizacija",
        "NAME": {
          "LABEL": "Vardas",
          "PLACEHOLDER": "Kategorijos pavadinimas",
          "HELP_TEXT": "Kategorijos pavadinimas ir piktograma bus naudojamas viešajame portale straipsniams skirstyti į kategorijas.",
          "ERROR": "Yra reikalingas vardas"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug kategorija, skirta URL",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Yra reikalingas slug"
        },
        "DESCRIPTION": {
          "LABEL": "Aprašymas",
          "PLACEHOLDER": "Pateikite trumpą kategorijos aprašymą.",
          "ERROR": "Būtinas aprašymas"
        },
        "BUTTONS": {
          "CREATE": "Keisti kategoriją",
          "CANCEL": "Atšaukti"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategorija atnaujinta sėkmingai",
          "ERROR_MESSAGE": "Nepavyko atnaujinti kategorijos"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Kategorija sėkmingai ištrinta",
          "ERROR_MESSAGE": "Nepavyko ištrinti kategorijos"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Ieškoti straipsnių",
      "PLACEHOLDER": "Ieškoti straipsnių",
      "NO_RESULT": "Straipsnių nerasta",
      "SEARCHING": "Ieškoma...",
      "SEARCH_BUTTON": "Ieškoti",
      "INSERT_ARTICLE": "Įterpti nuorodą",
      "IFRAME_ERROR": "URL yra tuščias arba neteisingas. Nepavyksta rodyti turinio.",
      "OPEN_ARTICLE_SEARCH": "Įterpti straipsnį iš Pagalbos centro",
      "SUCCESS_ARTICLE_INSERTED": "Straipsnis patalpintas sėkmingai",
      "PREVIEW_LINK": "Straipsnio peržiūra",
      "CANCEL": "Uždaryti",
      "BACK": "Atgal",
      "BACK_RESULTS": "Grįžti į rezultatus"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Palaikymo centras",
      "DESCRIPTION": "Sukurti patogius savitarnos portalus. Padėkite savo vartotojams pasiekti straipsnius ir gauti palaikymą 24 valandas per parą, 7 dienas per savaitę. Atnaujinkite savo prenumeratą, kad įjungtumėte šią funkciją.",
      "SELF_HOSTED_DESCRIPTION": "Sukurti patogius savitarnos portalus. Padėkite savo vartotojams pasiekti straipsnius ir gauti palaikymą 24 valandas per parą, 7 dienas per savaitę. Norėdami įjungti šią funkciją, susisiekite su administratoriumi.",
      "BUTTON": {
        "LEARN_MORE": "Sužinoti daugiau",
        "UPGRADE": "Patobulinti"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Keletas portalų",
          "DESCRIPTION": "Sukurkite kelis pagalbos centro portalus skirtingiems produktams naudodami tą pačią paskyrą."
        },
        "LOCALES": {
          "TITLE": "Lokalizacijos yra pilnai palaikomos",
          "DESCRIPTION": "Lokalizuokite portalą savo kalba. Mes palaikome visas kalbas ir leidžiame kiekvieno straipsnio vertimus."
        },
        "SEO": {
          "TITLE": "Paieškos variklio optimizavimui draugiškas dizainas",
          "DESCRIPTION": "Pritaikykite savo meta žymas, kad pagerintumėte matomumą paieškos sistemose naudodami mūsų SEO draugiškus puslapius."
        },
        "API": {
          "TITLE": "Pilnas API palaikymas",
          "DESCRIPTION": "Naudokite portalą kaip headless CMS su trečiųjų šalių front-end karkasais, pasitelkdami mūsų API."
        }
      }
    },
    "LOADING": "Įkeliama...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} peržiūra | {count} peržiūros",
          "DROPDOWN_MENU": {
            "PUBLISH": "Skelbti",
            "DRAFT": "Draft",
            "ARCHIVE": "Archyvuoti",
            "DELETE": "Ištrinti"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Paskelbta",
            "ARCHIVED": "Suarchyvuota"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Neįtraukta į kategorijas"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Visi straipsniai",
          "MINE": "Mano",
          "DRAFT": "Draft",
          "PUBLISHED": "Paskelbta",
          "ARCHIVED": "Suarchyvuota"
        },
        "CATEGORY": {
          "ALL": "Visos kategorijos"
        },
        "LOCALE": {
          "ALL": "Visos lokalizacijos"
        },
        "NEW_ARTICLE": "Naujas straipsnis"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Parašykite straipsnį",
          "SUBTITLE": "Parašykite turiningą straipsnį, pradėkime!",
          "BUTTON_LABEL": "Naujas straipsnis"
        },
        "MINE": {
          "TITLE": "Čia dar neparašėte jokių straipsnių",
          "SUBTITLE": "Visi jūsų parašyti straipsniai rodomi čia greitam pasiekimui."
        },
        "DRAFT": {
          "TITLE": "Juodraščiuose straipsnių nėra",
          "SUBTITLE": "Čia bus rodomi juodraščių straipsniai"
        },
        "PUBLISHED": {
          "TITLE": "Nėra paskelbtų straipsnių",
          "SUBTITLE": "Čia bus rodomi paskelbti straipsniai"
        },
        "ARCHIVED": {
          "TITLE": "Archyve straipsnių nėra",
          "SUBTITLE": "Suarchyvuoti straipsniai portale nerodomi, juos galite naudoti pasenusiems ar nebeaktualiems puslapiams pažymėti"
        },
        "CATEGORY": {
          "TITLE": "Šioje kategorijoje straipsnių nėra",
          "SUBTITLE": "Čia bus rodomi šios kategorijos straipsniai"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Nauja kategorija",
        "EDIT_CATEGORY": "Keisti kategoriją",
        "CATEGORIES_COUNT": "{n} kategorija | {n} kategorijos",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Kategorijos ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} straipsnių) | {categoryName} ({categoryCount} straipsnis)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Kategorijų nerasta",
        "SUBTITLE": "Čia bus rodomos kategorijos. Kategoriją galite pridėti paspaudę mygtuką „Nauja kategorija“."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} straipsnis | {count} straipsniai",
        "EXPAND": "Rodyti subkategorijas",
        "COLLAPSE": "Slėpti subkategorijas",
        "MENU": {
          "NEW_ARTICLE": "Naujas straipsnis",
          "ADD_SUBCATEGORY": "Pridėti subkategoriją",
          "EDIT": "Keisti",
          "DELETE": "Ištrinti"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorija sukurta sėkmingai",
            "ERROR_MESSAGE": "Nepavyko sukurti kategorijos"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorija atnaujinta sėkmingai",
            "ERROR_MESSAGE": "Nepavyko atnaujinti kategorijos"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorija sėkmingai ištrinta",
            "ERROR_MESSAGE": "Nepavyko ištrinti kategorijos"
          },
          "CONFIRM": {
            "TITLE": "Ištrinti kategoriją",
            "DESCRIPTION": "Ar tikrai norite ištrinti šią kategoriją? Jos straipsniai taps nekategorizuoti.",
            "DESCRIPTION_WITH_CHILDREN": "Ar tikrai norite ištrinti šią kategoriją? Jos straipsniai taps nekategorizuoti, o {count} jos subkategorija bus perkelta į aukščiausią lygį. | Ar tikrai norite ištrinti šią kategoriją? Jos straipsniai taps nekategorizuoti, o {count} jos subkategorijos bus perkeltos į aukščiausią lygį.",
            "CONFIRM": "Ištrinti"
          }
        },
        "HEADER": {
          "CREATE": "Sukurti kategoriją",
          "EDIT": "Keisti kategoriją",
          "DESCRIPTION": "Kategorijos redagavimas atnaujins kategoriją viešajame portale.",
          "PORTAL": "Portalas",
          "LOCALE": "Lokalizacija"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Vardas",
            "PLACEHOLDER": "Kategorijos pavadinimas",
            "ERROR": "Yra reikalingas vardas"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Slug kategorija, skirta URL",
            "ERROR": "Yra reikalingas slug",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Aprašymas",
            "PLACEHOLDER": "Pateikite trumpą kategorijos aprašymą.",
            "ERROR": "Būtinas aprašymas"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Tėvinė kategorija",
            "PLACEHOLDER": "Pasirinkite tėvinę kategoriją",
            "NONE": "Nėra (aukščiausias lygis)"
          }
        },
        "BUTTONS": {
          "CREATE": "Sukurti",
          "EDIT": "Atnaujinti",
          "CANCEL": "Atšaukti"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Nėra pasiekiamų lokalizacijų | {n} lokalizacija | {n} lokalizacijos",
      "NEW_LOCALE_BUTTON_TEXT": "Nauja lokalizacija",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} straipsnis | {count} straipsniai",
        "CATEGORIES_COUNT": "{count} kategorija | {count} kategorijos",
        "DEFAULT": "Pagal nutylėjimą",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Nustatyti kaip numatytąją",
          "DELETE": "Ištrinti"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Pridėti naują lokalizaciją",
        "DESCRIPTION": "Pasirinkite kalbą, kuria bus rašomas šis straipsnis. Ji bus pridėta prie jūsų vertimų sąrašo, o vėliau galėsite pridėti daugiau.",
        "COMBOBOX": {
          "PLACEHOLDER": "Pasirinkite lokalizaciją..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Lokalizacija sėkmingai pridėta",
          "ERROR_MESSAGE": "Nepavyko pridėti lokalizacijos. Bandykite dar kartą."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Išsaugoma...",
          "SAVED": "Išsaugota"
        },
        "PREVIEW": "Peržiūrėti",
        "PUBLISH": "Skelbti",
        "DRAFT": "Draft",
        "ARCHIVE": "Archyvuoti",
        "BACK_TO_ARTICLES": "Grįžti į straipsnius"
      },
      "DRAFT": {
        "PENDING_LABEL": "Nepaskelbti pakeitimai",
        "PROMOTE": "Skelbti pakeitimus",
        "DISCARD": "Atmesti pakeitimus",
        "PROMOTE_SUCCESS": "Juodraščio pakeitimai paskelbti aktyviame straipsnyje",
        "PROMOTE_ERROR": "Nepavyko paskelbti juodraščio pakeitimų",
        "DISCARD_SUCCESS": "Juodraščio pakeitimai atmesti",
        "DISCARD_ERROR": "Nepavyko atmesti juodraščio pakeitimų"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Versijų istorija",
        "TITLE": "Versijų istorija",
        "BACK": "Grįžti į straipsnį",
        "LOADING": "Įkeliamos versijos...",
        "EMPTY": "Versijų dar nėra. Šio straipsnio pakeitimai bus rodomi čia.",
        "EMPTY_CONTENT": "Ši versija neturi turinio.",
        "CURRENT_BADGE": "Dabartinė",
        "RESTORED_BADGE": "Atkurta",
        "AUTOMATED_USER": "Automatinis atnaujinimas",
        "RESTORE": "Atkurti šią versiją",
        "RESTORE_DIALOG": {
          "TITLE": "Atkurti šią versiją?",
          "DESCRIPTION": "Straipsnis bus grąžintas į šios versijos tekstą. Nieko neprarasite — dabartinis tekstas išliks istorijoje, o paskelbtas straipsnis toliau rodys aktyvią versiją, kol paskelbsite pakeitimą.",
          "CONFIRM": "Atkurti"
        },
        "RESTORE_SUCCESS": "Versija atkurta",
        "RESTORE_ERROR": "Nepavyko atkurti šios versijos",
        "FETCH_ERROR": "Nepavyko įkelti versijų istorijos"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Daugiau savybių",
        "TRANSLATE": "Versti",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Neįtraukta į kategorijas",
        "EDITOR_PLACEHOLDER": "Rašykite...",
        "HTML_EMBED": {
          "TITLE": "Įterpti tinkintą HTML",
          "DESCRIPTION": "Įklijuokite gryną HTML, pvz., iframe, įterpinį ar valdiklio fragmentą. Jis bus rodomas toks, koks yra, paskelbtame straipsnyje.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Įterpti"
        },
        "PRIMARY_CATEGORY": "Pagrindinė kategorija"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Straipsnio savybės",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Meta aprašymas",
        "META_DESCRIPTION_PLACEHOLDER": "Pridėti meta aprašymą",
        "META_TITLE": "Meta antraštė",
        "META_TITLE_PLACEHOLDER": "Pridėti meta antraštę",
        "META_TAGS": "Meta žymos",
        "META_TAGS_PLACEHOLDER": "Pridėti meta žymas",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Kalbų versijos",
        "LANGUAGE_MUTATIONS_EMPTY": "Kol kas nėra susietų straipsnių",
        "ADD_MUTATION": "Pridėti",
        "REMOVE_MUTATION": "Pašalinti"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Susieti kalbų versijas",
        "SEARCH_PLACEHOLDER": "Ieškoti straipsnių pagal pavadinimą",
        "EMPTY": "Atitinkančių straipsnių nerasta",
        "CANCEL": "Atšaukti",
        "ADD_SELECTED": "Pridėti pasirinktus",
        "SUCCESS": "Kalbų versijos atnaujintos",
        "ERROR": "Nepavyko atnaujinti kalbų versijų"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Versti straipsnį",
        "DESCRIPTION": "Pasirinkite kalbas, į kurias norite išversti šį straipsnį. Jau išverstos kalbos bus iš naujo išverstos į juodraštį, kad galėtumėte jį peržiūrėti.",
        "EMPTY": "Nėra kitų galimų kalbų.",
        "CONNECTED_BADGE": "Išversta",
        "CANCEL": "Atšaukti",
        "TRANSLATE": "Versti",
        "SUCCESS": "Vertimas netrukus prasidės. Išversti straipsniai netrukus bus rodomi kaip kalbų versijos.",
        "ERROR": "Nepavyko pradėti vertimo"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "Išsaugant straipsnį įvyko klaida"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Naujas portalas",
      "PORTALS": "Portalas",
      "CREATE_PORTAL": "Kurkite ir tvarkykite kelis portalus",
      "ARTICLES": "straipsniai",
      "DOMAIN": "domenas",
      "PORTAL_NAME": "Portalo pavadinimas"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Sukurti naują portalą",
      "DESCRIPTION": "Suteikite savo portalui pavadinimą ir sukurkite patogų naudoti URL slug. Abu vėliau galėsite pakeisti nustatymuose.",
      "CONFIRM_BUTTON_LABEL": "Sukurti",
      "NAME": {
        "LABEL": "Vardas",
        "PLACEHOLDER": "Naudotojo vadovas",
        "MESSAGE": "Pasirinkite savo portalo pavadinimą.",
        "ERROR": "Yra reikalingas vardas"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Yra reikalingas slug",
        "FORMAT_ERROR": "Naudokite tik raides, skaičius ir brūkšnelius, pavyzdžiui: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logotipas",
          "IMAGE_UPLOAD_ERROR": "Nepavyko įkelti vaizdo! Prašau, pabandykite dar kartą",
          "IMAGE_UPLOAD_SUCCESS": "Paveikslėlis sėkmingai pridėtas. Spustelėkite „Išsaugoti pakeitimus“, kad išsaugotumėte logotipą",
          "IMAGE_DELETE_SUCCESS": "Logotipas sėkmingai ištrintas",
          "IMAGE_DELETE_ERROR": "Nepavyko ištrinti logotipo",
          "IMAGE_UPLOAD_SIZE_ERROR": "Paveiksliuko dydis turi būti mažesnis nei {size} MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Vardas",
          "PLACEHOLDER": "Portalo pavadinimas",
          "ERROR": "Yra reikalingas vardas"
        },
        "HEADER_TEXT": {
          "LABEL": "Antraštės tekstas",
          "PLACEHOLDER": "Portalo antraštės tekstas"
        },
        "PAGE_TITLE": {
          "LABEL": "Puslapio antraštė",
          "PLACEHOLDER": "Portalo puslapio antraštė"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Nuoroda į pagrindinį puslapį",
          "PLACEHOLDER": "Portalo nuoroda į pagrindinį puslapį",
          "ERROR": "Neteisingas URL. Nuoroda į pagrindinį puslapį turi prasidėti „http://“ arba „https://“."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portalo slug"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Tiesioginio pokalbio valdiklis",
          "PLACEHOLDER": "Pasirinkite tiesioginio pokalbio valdiklį",
          "HELP_TEXT": "Pasirinkite tiesioginio pokalbio valdiklį, kuris bus rodomas jūsų pagalbos centre"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Viešai prieinamas",
          "HELP_TEXT": "Padarykite portalą prieinamą visiems, turintiems nuorodą.",
          "OPTIONS": {
            "PUBLIC": "Taip",
            "PRIVATE": "Ne"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Nuorodos paskirtis",
          "HELP_TEXT": "Pasirinkite, ar straipsnių nuorodos atsidaro dabartiniame lange, ar naujame.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Dabartinis langas",
            "NEW_WINDOW": "Naujas langas"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Numatytasis paveikslėlio dydis",
          "HELP_TEXT": "Dydis, taikomas kiekvienam į straipsnį įterptam paveikslėliui. Pasirinkite Original, jei norite įterpti paveikslėlius jų originaliu dydžiu ir kiekvienam paveikslėliui pasirinkti dydį atskirai."
        },
        "BRAND_COLOR": {
          "LABEL": "Prekės ženklo spalva"
        },
        "CUSTOM_HTML": {
          "LABEL": "Tinkintas HTML",
          "PLACEHOLDER": "<!-- Čia įklijuokite savo analitikos arba stebėjimo fragmentą -->",
          "HELP_TEXT": "Įterpiama kiekvieno palaikymo centro puslapio <body> žymos pradžioje. Naudokite jį su Google Analytics, Google Tag Manager arba bet kokiu kitu stebėjimo fragmentu. Kodas atvaizduojamas lygiai taip, kaip įvestas, ir nėra tikrinamas."
        },
        "SAVE_CHANGES": "Išsaugoti pakeitimus"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Personalizuotas domenas",
          "LABEL": "Personalizuotas domenas:",
          "DESCRIPTION": "Savo portalą galite talpinti pasirinktiniame domene. Pavyzdžiui, jei jūsų svetainė yra yourdomain.com ir norite, kad portalas būtų pasiekiamas adresu docs.yourdomain.com, tiesiog įveskite jį šiame lauke.",
          "PLACEHOLDER": "Portalo personalizuotas domenas",
          "EDIT_BUTTON": "Redaguoti pasirinktinį domeną",
          "ADD_BUTTON": "Pridėti pasirinktinį domeną",
          "DIALOG": {
            "ADD_HEADER": "Pridėti pasirinktinį domeną",
            "EDIT_HEADER": "Redaguoti pasirinktinį domeną",
            "ADD_CONFIRM_BUTTON_LABEL": "Pridėti domeną",
            "EDIT_CONFIRM_BUTTON_LABEL": "Atnaujinti domeną",
            "LABEL": "Personalizuotas domenas",
            "PLACEHOLDER": "Portalo personalizuotas domenas",
            "ERROR": "Būtina nurodyti pasirinktinį domeną"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "DNS konfigūracija",
            "DESCRIPTION": "Prisijunkite prie savo DNS paslaugų teikėjo paskyros ir pridėkite toliau nurodytą savo subdomeno CNAME įrašą.",
            "HELP_TEXT": "Kai tai padarysite, galite kreiptis į mūsų palaikymo komandą ir paprašyti automatiškai sugeneruoto SSL sertifikato.",
            "CONFIRM_BUTTON_LABEL": "Supratau!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Ištrinti {portalName}",
          "HEADER": "Trinti portalą",
          "DESCRIPTION": "Visam laikui ištrinti šį portalą. Šio veiksmo negalima anuliuoti",
          "DIALOG": {
            "HEADER": "Ar tikrai norite ištrinti {portalName}?",
            "DESCRIPTION": "Tai negrįžtamas veiksmas, kurio nebus galima anuliuoti.",
            "CONFIRM_BUTTON_LABEL": "Ištrinti"
          }
        },
        "EDIT_CONFIGURATION": "Redaguoti konfigūraciją"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portalas sukurtas sėkmingai",
          "ERROR_MESSAGE": "Nepavyko sukurti portalo"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portalas atnaujintas sėkmingai",
          "ERROR_MESSAGE": "Nepavyko atnaujinti portalo"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Priedai",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Pridėti failą",
      "DROP_HERE": "Vilkite ir numeskite failus čia",
      "COPY_LINK": "Kopijuoti nuorodą",
      "LINK_COPIED": "Nuoroda nukopijuota į iškarpinę",
      "COPY_FAILED": "Nepavyko nukopijuoti nuorodos",
      "DELETE": "Ištrinti",
      "CANCEL": "Atšaukti",
      "QUEUED": "Eilėje",
      "UPLOADING": "Įkeliama",
      "UPLOAD_FAILED": "Nepavyko įkelti failo",
      "FILE_TOO_LARGE": "Failas viršija 40 MB dydžio limitą"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Vertimų žodynas",
        "DESCRIPTION": "Čia apibrėžti terminai pridedami prie AI vertimo užklausos, kad jie visada būtų verčiami vienodai. Pagrindinis terminas parašytas {locale} kalba."
      },
      "NEW_TERM": "Naujas terminas",
      "EMPTY_STATE": {
        "TITLE": "Kol kas nėra žodyno terminų",
        "SUBTITLE": "Pridėkite terminą ir jo vertimą kiekvienai kalbai. Verčiant straipsnį, šie terminai yra užtikrinami, kad jūsų produkto terminija išliktų nuosekli."
      },
      "LIST": {
        "TERM": "Terminas",
        "TRANSLATIONS": "Vertimai",
        "ACTIONS": "Veiksmai"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Pridėti terminą",
          "EDIT": "Keisti terminą",
          "DESCRIPTION": "Toliau nurodytas terminas yra užtikrinamas AI verčiant jūsų pagalbos centro straipsnius.",
          "PORTAL": "Portalas",
          "PRIMARY_LANGUAGE": "Pagrindinė kalba"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Terminas ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "Yra reikalingas terminas"
          },
          "DESCRIPTION": {
            "LABEL": "Kontekstas / pastabos (neprivaloma)",
            "PLACEHOLDER": "Kada ir kaip šis terminas naudojamas, kad vertėjui būtų lengviau jį atskirti nuo kitų reikšmių."
          },
          "TRANSLATIONS": "Vertimai",
          "TRANSLATION_PLACEHOLDER": "Palikite tuščią, kad AI galėtų versti laisvai",
          "AUTO_TRANSLATE": {
            "BUTTON": "Versti į visas kalbas",
            "CONFIRM": "Versti į {count} kalbas su AI?",
            "CONFIRM_BUTTON": "Versti",
            "CANCEL": "Atšaukti",
            "SUCCESS": "Vertimai sugeneruoti — peržiūrėkite ir išsaugokite",
            "ERROR": "Nepavyko automatiškai išversti, bandykite dar kartą"
          }
        },
        "BUTTONS": {
          "CREATE": "Pridėti terminą",
          "EDIT": "Išsaugoti",
          "CANCEL": "Atšaukti"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Terminas sėkmingai pridėtas",
            "ERROR_MESSAGE": "Nepavyko pridėti termino, bandykite dar kartą"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Terminas sėkmingai atnaujintas",
            "ERROR_MESSAGE": "Nepavyko atnaujinti termino, bandykite dar kartą"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Ištrinti terminą",
          "DESCRIPTION": "Ar tikrai norite ištrinti šį terminą? Jis nebebus užtikrinamas verčiant.",
          "CONFIRM": "Ištrinti"
        },
        "API": {
          "SUCCESS_MESSAGE": "Terminas sėkmingai ištrintas",
          "ERROR_MESSAGE": "Nepavyko ištrinti termino, bandykite dar kartą"
        }
      }
    }
  }
}
